/* Clon ore — ajustes propios del clon sobre el tema fuente (Olivia 16.5.3 de la tienda fuente), en Quiero Uno.
 * 1. Packs reconstruidos (ore-kb, antes Kaching Bundles): elegir una barra la marca y guarda su índice.
 * 2. Releasit de Quiero Uno: su botón se viste como el "Agregar al carrito" de la fuente, y al abrir el formulario se
 *    marca la oferta del mismo índice que el pack elegido (1, 2 o 3 frascos).
 * 3. El otro botón de compra de la fuente ("Consigue tu Biorelia") abre el mismo formulario.
 * Observadores convergentes (gotchas §E): comparan antes de escribir y se apagan solos.
 */
(function () {
  'use strict';
  var RSI_BTN = '._rsi-buy-now-button', RSI_MODAL = '#_rsi-cod-form-modal._rsi-cod-form-modal-open',
      RSI_OFFER = '._rsi-quantity-offers-offer-container', RSI_SEL = '_rsi-quantity-offers-selected';
  // el pago al recibir dentro del botón (plantilla M9, Aldhair)
  var TEXTO_BOTON = 'Pedir ahora · Pago al recibir';
  var ZONA = '#MainContent ' + RSI_BTN + ', main ' + RSI_BTN;

  // ---------- 1. estilo del botón de Releasit, igual al de la fuente
  var css = document.createElement('style');
  css.textContent =
    '.product-form__submit.ore-oculto{display:none!important}' +
    'body ' + RSI_BTN + '._rsi-buy-now-button-product *{color:#fff!important;font-family:inherit!important;font-size:inherit!important;' +
    'font-weight:inherit!important;letter-spacing:inherit!important;text-transform:inherit!important}' +
    // la fuente no tiene ícono en el botón
    'body ' + RSI_BTN + '._rsi-buy-now-button-product svg,body ' + RSI_BTN + '._rsi-buy-now-button-product img{display:none!important}';
  // buenas prácticas (2-oct-2026): marca de los anuncios arriba y sin puntos de fuga en la cabecera; sin logos de
  // tarjeta (se paga al recibir); botones de pedido entre secciones; la compra en 3 pasos
  css.textContent +=
    '.header header-drawer,.header .header__inline-menu,.header .header__icons,.header .header__search{display:none!important}' +
    '.header{display:flex!important;justify-content:center!important;align-items:center}' +
    '.header__heading,.header__heading-link{grid-area:auto!important;margin:0 auto!important;justify-self:center!important;text-align:center;width:auto}' +
    '.ore-marca{display:block;font-family:Poppins,sans-serif;font-weight:700;font-size:24px;letter-spacing:.14em;color:#064F3B;padding:6px 0}' +
    '.footer__payment,[class*="list-payment-lm"]{display:none!important}' +
    '.ore-cta-sec{display:flex;justify-content:center;padding:6px 16px 26px}' +
    '.ore-cta-sec .buybutton{display:flex;flex-direction:column;gap:3px;width:100%;max-width:520px;padding:1rem 2rem;background:#064F3B!important;color:#fff!important;border-radius:6px;font-weight:600}' +
    '.ore-cta-sec .buybutton:after,.ore-cta-sec .buybutton:before{display:none!important}' +
    '.ore-cta-sub{font-size:74%}' +
    '.ore-compra{max-width:620px;margin:0 auto;padding:30px 18px 10px;font-family:Poppins,sans-serif}' +
    '.ore-compra-eyebrow{font-size:12px;letter-spacing:.12em;color:#064F3B;font-weight:700;margin:0 0 6px}' +
    '.ore-compra h2{margin:0 0 14px;font-size:24px}' +
    '.ore-compra ol{list-style:none;margin:0;padding:0;counter-reset:p;display:grid;gap:10px}' +
    '.ore-compra li{counter-increment:p;position:relative;padding:12px 14px 12px 54px;border:1px solid #dfe7e3;border-radius:10px;background:#fff}' +
    '.ore-compra li::before{content:counter(p);position:absolute;left:14px;top:12px;width:28px;height:28px;border-radius:50%;background:#064F3B;color:#fff;display:grid;place-items:center;font-weight:700;font-size:14px}' +
    '.ore-compra li b{display:block;font-size:15px}.ore-compra li span{font-size:14px;opacity:.8}' +
    '.ore-compra-remate{margin:14px 0 0;padding:12px 14px;border-left:4px solid #064F3B;background:#f1f6f3;font-weight:600}';
  document.head.appendChild(css);

  var ESTILO = { 'background': 'rgb(6, 79, 59)', 'color': 'rgb(255, 255, 255)', 'border-radius': '6px', 'border': '0px',
    'box-shadow': 'none', 'min-height': '54px', 'width': '100%', 'font-family': 'Poppins, sans-serif', 'font-size': '14px',
    'font-weight': '400', 'letter-spacing': '1px', 'text-transform': 'uppercase', 'animation': 'none', 'padding': '0px 30px' };
  function pintar(b) {
    Object.keys(ESTILO).forEach(function (k) {
      if (b.style.getPropertyValue(k) !== ESTILO[k] || b.style.getPropertyPriority(k) !== 'important') b.style.setProperty(k, ESTILO[k], 'important');
    });
  }
  function vestirBoton(b) {
    // el texto de Releasit va en el último nodo con texto; se cambia una sola vez
    if (b.getAttribute('data-ore-vestido')) return;
    var nodos = [], w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT);
    while (w.nextNode()) if (w.currentNode.nodeValue.trim()) nodos.push(w.currentNode);
    if (!nodos.length) return;
    nodos[nodos.length - 1].nodeValue = TEXTO_BOTON;
    b.setAttribute('data-ore-vestido', '1');
    pintar(b);
    // Releasit pone su color con estilo en línea y !important: se repinta si lo vuelve a poner (solo 8 s, comparando antes)
    var mo = new MutationObserver(function () { pintar(b); });
    mo.observe(b, { attributes: true, attributeFilter: ['style'] });
    setTimeout(function () { mo.disconnect(); }, 8000);
    // con el botón de Releasit puesto, el "Agregar al carrito" del tema sobra (iría al carrito, no al formulario)
    document.querySelectorAll('main .product-form__submit').forEach(function (a) {
      if (!a.classList.contains('ore-oculto')) a.classList.add('ore-oculto');
    });
  }
  var t0 = Date.now();
  (function buscar() {
    var bs = document.querySelectorAll(ZONA);
    bs.forEach(vestirBoton);
    if (Date.now() - t0 < 8000 && (!bs.length || [].some.call(bs, function (b) { return !b.getAttribute('data-ore-vestido'); })))
      setTimeout(buscar, 300);
  })();

  // ---------- 2. packs
  window.ORE_IDX = 0;
  function elegir(idx) {
    idx = Number(idx) || 0;
    window.ORE_IDX = idx;
    document.querySelectorAll('.ore-kb__bar[data-ore-idx]').forEach(function (bar) {
      var si = Number(bar.getAttribute('data-ore-idx')) === idx;
      if (bar.classList.contains('ore-kb__bar--selected') !== si) bar.classList.toggle('ore-kb__bar--selected', si);
      var r = bar.querySelector('input[type=radio]');
      if (r && r.checked !== si) r.checked = si;
    });
  }
  document.addEventListener('click', function (e) {
    var bar = e.target.closest && e.target.closest('.ore-kb__bar[data-ore-idx]');
    if (bar) { e.preventDefault(); elegir(bar.getAttribute('data-ore-idx')); }
  });
  var pre = document.querySelector('.ore-kb__bar--selected[data-ore-idx]');
  elegir(pre ? pre.getAttribute('data-ore-idx') : 0);

  // ---------- 3. al abrir el formulario de Releasit, marcar la oferta del pack elegido
  function sincronizar() {
    var inicio = Date.now(), clics = 0, obs = null, timer = null;
    function intentar() {
      var modal = document.querySelector(RSI_MODAL);
      if (!modal) return false;
      var ofertas = modal.querySelectorAll(RSI_OFFER);
      if (!ofertas.length) return false;
      var o = ofertas[Math.min(window.ORE_IDX, ofertas.length - 1)];
      if (o.classList.contains(RSI_SEL)) return true;
      if (clics < 6) { clics++; (o.querySelector('._rsi-quantity-offers-offer') || o).click(); }
      return false;
    }
    function fin() { if (obs) obs.disconnect(); if (timer) clearInterval(timer); }
    if (intentar()) return;
    obs = new MutationObserver(function () { if (intentar() || Date.now() - inicio > 6000) fin(); });
    obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    timer = setInterval(function () { if (intentar() || Date.now() - inicio > 6000) fin(); }, 300);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest(RSI_BTN)) sincronizar();
  }, true);

  // ---------- 4. "Consigue tu Biorelia" abre el mismo formulario (en la fuente pulsaba el botón del carrito)
  function abrirFormulario() {
    var b = document.querySelector(ZONA) || document.querySelector(RSI_BTN);
    if (b) { b.click(); return true; }
    return false;
  }
  document.addEventListener('click', function (e) {
    var otro = e.target.closest && e.target.closest('.buybutton');
    if (!otro) return;
    if (abrirFormulario()) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
})();
